import { Base } from '@studiometa/js-toolkit';

/**
 * ModalTrigger class.
 */
export default class ModalTrigger extends Base {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: 'ModalTrigger',
    emits: ['open-modal'],
    options: {
      target: String,
    },
  };

  /**
   * onClick
   */
  onClick() {
    this.$emit('open-modal', this.$options.target);
  }
}
